import React from "react"

function Bookcase() {
    return (
        <div>
            <h3>Nigel does not have many books on his small bookcase.</h3>
            <div className="imageTextWrapper officeBooksWrapper"></div>
        </div>
    )
}

export default Bookcase